module.exports = __webpack_public_path__ + "img/shield.42ee3036.svg";